import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";
import { money } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export default function ProductCard({ product, index = 0, tall = false }) {
  const { add } = useCart();

  return (
    <Reveal delay={index * 0.07} className="h-full">
      <div className="group flex h-full flex-col" data-testid={`product-card-${product.id}`}>
        <Link to={`/product/${product.id}`} className="relative block overflow-hidden border border-white/10 bg-onyx">
          <div className={tall ? "aspect-[3/4]" : "aspect-[4/5]"}>
            <img
              src={product.image}
              alt={product.name}
              loading="lazy"
              className="h-full w-full object-cover opacity-90 transition-all duration-700 ease-out group-hover:scale-[1.05] group-hover:opacity-100"
            />
          </div>
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_25%,rgba(255,69,0,0.14),transparent_60%)] opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
          <div className="pointer-events-none absolute inset-0 shadow-[inset_0_0_80px_rgba(0,0,0,0.55)]" />
          {product.stock <= 8 && (
            <span className="absolute left-3 top-3 border border-brass/40 bg-obsidian/80 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-brass backdrop-blur">
              {product.stock <= 0 ? "Sold out" : `${product.stock} remain`}
            </span>
          )}
          <span className="absolute bottom-3 right-3 bg-obsidian/85 px-3 py-1.5 font-mono text-xs tracking-wider text-bone backdrop-blur">
            {money(product.price)}
          </span>
        </Link>
        <div className="flex flex-1 items-start justify-between gap-4 pt-4">
          <div>
            <Link to={`/product/${product.id}`} className="font-display text-xl leading-tight text-bone transition-colors hover:text-vermilion">
              {product.name}
            </Link>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.3em] text-faint">{product.category}</p>
          </div>
          <button
            onClick={() => {
              add(product);
              toast.success(`${product.name} added to your collection`);
            }}
            disabled={product.stock <= 0}
            data-testid={`add-to-cart-button-${product.id}`}
            aria-label={`Add ${product.name} to cart`}
            className="shrink-0 border border-white/15 p-2.5 text-smoke transition-all duration-300 hover:border-vermilion hover:bg-vermilion hover:text-obsidian disabled:cursor-not-allowed disabled:opacity-30"
          >
            <Plus size={16} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </Reveal>
  );
}
